import { sectionsMapper } from '../../../constants/routes';
import { HEADER_OFFSET_SCROLL } from '../../../constants';
import { ITabData } from '../types';

export function mapClausesToTabs(clauses: HTMLElement[]) {
  if (clauses.length < 1) {
    return [];
  }

  return clauses
    .map((tabElement: HTMLElement) => {
      const anchor = tabElement.getAttribute('id') || '';

      return {
        title: sectionsMapper[anchor],
        anchor,
        point: tabElement.offsetTop - HEADER_OFFSET_SCROLL,
      };
    })
    .filter((clause: ITabData) => Boolean(clause.title && clause.anchor))
    .sort((a, b) => a.point - b.point);
}
